import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const TestimonialsThunk = createAsyncThunk(
	'TestimonialsThunk`',
	async (_, ThunkApi) => {
		const { rejectWithValue } = ThunkApi;
		try {
			const res = await axios.get(
				'https://api.act2hf.com/api/public/testimonials',
			);

			return res?.data;
		} catch (error) {
			return rejectWithValue(error.response.data);
		}
	},
);
